import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { addLineCollection } from "@insite/client-framework/Services/CartService";

import {
    chain,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/AddLinesToCart";


replaceInChain(chain, RequestDataFromApi, async props => {
    try{
        props.apiResult = await addLineCollection(props.apiParameter);
    }
    catch (error) {
       console.log("error",error);
    }
});

